import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import apiService from "apiService";
import Autocomplete from "react-autocomplete";
import ALERT, { confirmedAlert, toast } from "view/component/Alert";
import "../component/css/costumModal.css"
import Table from "view/component/Table";

export default class ModalAddBiling extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            biling: [],
            dataTreatments: [],
            treatments: [
                {
                    visit_id: this.props.data?.id,
                    visit_inpatient_detail_id: "",
                    treatment_id: "",
                    log: "0",
                    treatment: { name: "" },
                },
            ],
            total: [],
            payment_type_id: this.props.data?.payment_type_id,
            payment_types: [],
            loading: false
        };
    }

    componentDidMount() {
        this.fetchPaymentTypes();
        this.getBilingByPaymentVisitId();
    }

    getBilingByPaymentVisitId = async () => {
        let res = await apiService.get('registration/payment/get_payment_by_visit/' + this.props.data?.id);
        if (res.code == 200) {
            this.setState({ biling: res.data });
        } else {
            this.setState({ biling: [] });
        }
    }

    fetchPaymentTypes = async () => {
        const res = await apiService.get("management/payment_types/read");
        if (res) {
            if (res.status === "success.") {
                this.setState({
                    payment_types: res.data,
                });
            }
        }
    };
    //tindakan
    handleInputNameChangeTreatments = (idx) => (evt) => {
        const val = evt.split("-", 4);
        const newTreatments = this.state.treatments.map((tr, sidx) => {
            if (idx !== sidx) return tr;
            return {
                visit_id: this.props.data?.id,
                visit_inpatient_detail_id: "1",
                treatment_id: val[0],
                log: "0",
                treatment: { name: val[1] + ' ' + val[2] },
                price: val[2],
                payment_type: 1
            };
        });

        this.setState({ treatments: newTreatments });
        this.setState({ value: evt });
    };

    postTreatments = async (e) => {
        this.setState({ loading: true })
        const treatment = this.state.treatments;
        const res = await apiService.put("/registration/treatment/update", { treatment });
        if (res.code == 200) {
            // await apiService.post(`/fhir/satu_sehat/procedure/${this.state.visit_id}`, {})
            // this.changeDetilData(res.data);
            let get = await this.getBilingByPaymentVisitId();
            toast({ status: 'success', text: 'berhasil menambah data' });
        } else {
            toast({ status: 'error', text: 'gagal data' });
        }
        this.setState({ loading: false })
    };
    handleRemoveInputTreatments = (idx) => (evt) => {
        const treatments = [...this.state.treatments];
        treatments[idx].log = 1;
        if (treatments[idx].treatment_id !== "") {
            this.setState({ treatments });
        } else {
            this.setState({
                [evt.target.name]: this.state.treatments.filter(
                    (s, sidx) => idx !== sidx
                ),
            });
        }
    };
    retrieveDataAsynchronouslyTreatments = async (e) => {
        // console.log(e);
        let payment_type_id = this.state.payment_type_id;
        let res = await apiService.get(
            "management/treatments_price/read?payment_type=" +
            payment_type_id +
            "&keyword=" +
            e
        );
        if (res.code === 200) {
            this.setState({
                dataTreatments: res.data,
            });
        } else {
            // console.error("Cannot load data from remote source");
            this.setState({
                dataTreatments: [],
            });
        }
    };
    onChangeTreatments = (idx) => (evt) => {
        const newTreatments = this.state.treatments.map((tr, sidx) => {
            if (idx !== sidx) return tr;
            return {
                visit_id: this.props.data?.id,
                visit_inpatient_detail_id: "1",
                treatment_id: "",
                log: "0",
                treatment: { name: evt.target.value },
            };
        });

        this.setState({ treatments: newTreatments });

        /**
         * Handle the remote request with the current text !
         */
        const par = evt.target.value;
        // if (evt.target.value.length > 2) {
        // setTimeout(event => {
        // this.retrieveDataAsynchronouslyTreatments(par);
        // }, 300);
        // console.log("The Input Text has changed to ", par);
        // }
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            //search function
            this.retrieveDataAsynchronouslyTreatments(par);
        }, 500);
    };
    getItemValueTreatments(item) {
        // You can obviously only return the Label or the component you need to show
        // In this case we are going to show the value and the label that shows in the input
        // something like "1 - Microsoft"
        return `${item.treatment_id}-${item.treatment.name}-${item.price}-${item.id}`;
    }
    handleAddInput = (x) => (evt) => {
        this.setState({
            [evt.target.name]: x,
        });
    };
    render() {
        // console.log(this.props);
        return (
            <Modal {...this.props} aria-labelledby="modal" dialogClassName="modal-70w" >
                <ModalHeader closeButton>
                    <ModalTitle>
                        <h3>Tambah Biling</h3>
                    </ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="bg-primary text-center text-white">Penambahan</div>
                            <div className="form-group">
                                <div>Jenis Pembayaran</div>
                                <div>
                                    <select
                                        className='form-control form-control-sm '
                                        name='payment_type_id'
                                        id='payment_type_id'
                                        placeholder='pembayaran'
                                        value={this.state.payment_type_id}
                                        onChange={e => this.setState({ payment_type_id: e.target.value })}>
                                        {
                                            this.state.payment_types?.map((a, b) => (
                                                <option key={b} value={a.id}>{a.name}</option>
                                            ))
                                        }

                                    </select>
                                </div>
                            </div>
                            <div>
                                Tindakan
                            </div>
                            <div className="form-group row">
                                <div className="col-md-10">
                                    {this.state.treatments.map((tr, idx) => {
                                        if (tr.log < 1) {
                                            return (
                                                <div key={idx} className="form-group ml-0 row">
                                                    {
                                                        <Autocomplete
                                                            inputProps={{
                                                                className: "form-control form-control-sm",
                                                                placeholder: "ketikkan minimal 3 huruf tindakan",
                                                            }}
                                                            items={this.state.dataTreatments}
                                                            getItemValue={this.getItemValueTreatments}
                                                            renderItem={(item, highlighted) => (
                                                                <div
                                                                    key={item.id}
                                                                    style={{
                                                                        backgroundColor: highlighted
                                                                            ? "#eee"
                                                                            : "transparent",
                                                                    }}
                                                                >
                                                                    {item.id} - {item.treatment.name}-
                                                                    {item.price}
                                                                </div>
                                                            )}
                                                            value={this.state.treatments[idx].treatment.name}
                                                            onChange={this.onChangeTreatments(idx)}
                                                            onSelect={this.handleInputNameChangeTreatments(idx)}
                                                            menuStyle={{
                                                                borderRadius: "3px",
                                                                boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                                                background: "rgba(255, 255, 255, 0.9)",
                                                                padding: "2px 0",
                                                                fontSize: "90%",
                                                                // position: "absolute",
                                                                overflow: "scroll",
                                                                zIndex: "100",
                                                                maxHeight: "100%", // TODO: don't cheat, let it flow to the bottom
                                                            }}
                                                            wrapperStyle={{
                                                                maxWidth: "90%",
                                                                flex: "0 0 90%",
                                                                overflow: "scroll",
                                                                maxHeight: '300px'
                                                            }}
                                                        />
                                                    }

                                                    <button
                                                        className="btn btn-sm btn-danger"
                                                        style={{ maxWidth: "10%", maxHeight: "32px" }}
                                                        name="treatments"
                                                        onClick={this.handleRemoveInputTreatments(idx)}
                                                        type="button"
                                                    >
                                                        -
                                                    </button>
                                                </div>
                                            );
                                        }
                                    })}
                                </div>
                                <button
                                    type="button"
                                    name="treatments"
                                    style={{ marginLeft: "2%" }}
                                    onClick={this.handleAddInput(
                                        this.state.treatments.concat([
                                            {
                                                visit_id: "",
                                                visit_inpatient_detail_id: "",
                                                treatment_id: "",
                                                log: "0",
                                                treatment: { name: "" },
                                                price: 0,
                                                payment_type: ''
                                            },
                                        ])
                                    )}
                                    className="btn btn-sm btn-primary"
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="bg-success text-center text-white">Biling</div>
                            <Table
                                pagination={false}
                                headers={['No', 'Keterangan', 'biaya']}
                                data={this.state.biling}
                                columnMapper={(value, i) => [
                                    value.name,
                                    value.price
                                ]
                                }
                            />
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <div className="row">
                        <div className="col-12">
                            <button
                                type="button"
                                onClick={this.props.onHide}
                                className="btn btn-outline-secondary"
                            >
                                Batal
                            </button>
                            <button disable={this.state.loading} onClick={() => this.postTreatments()} type="submit" className="btn btn-primary">
                                Simpan
                            </button>
                        </div>
                    </div>
                </ModalFooter>
            </Modal >
        );
    }
}
